<script setup lang="ts">
import { CircleQuestionMark, Heart } from 'lucide-vue-next'

const emit = defineEmits<{
  navbarClose: []
}>()

const { t } = useI18n()

const { wishlist } = useWishlist()
const { toggle: toggleWishlistSidebar } = useWishlistSidebarUiState()
</script>

<template>
  <div class="ml-4 flex gap-3 justify-around md:hidden">
    <!-- Locale Switcher -->
    <DropdownLocaleSwitcher
      :icon-size="16"
      text-class="text-gray-800 text-caption font-medium"
      @navbar-close="emit('navbarClose')"
    />

    <!-- Wishlist -->
    <div
      class="flex items-center gap-2 text-gray-800 text-caption font-medium cursor-pointer hover:underline"
      @click="toggleWishlistSidebar(true)"
    >
      <Heart
        :size="20"
        :fill="wishlist?.items?.length > 0 ? 'currentColor' : 'none'"
      />
      <span>{{ t('general.wishlist') }}</span>
    </div>

    <!-- Contact Info -->
    <NuxtLink
      :to="`https://help.gokonfetti.com`"
      class="flex items-center gap-2 text-gray-800 text-caption font-medium hover:underline"
    >
      <CircleQuestionMark class="h-5 w-5" />
      <span>{{ t('general.contactUs') }}</span>
    </NuxtLink>
  </div>
</template>
